export const SET_PERMISSIONS = 'setPermissions';
export const SET_LCODE_MANUFACTURER_WHITELIST = 'setLCodeManufacturerWhitelist';
export const SET_USER_FACILITIES = 'setUserFacilities';
export const SET_CHOOSE_FACILITY_STATUS = 'setChooseFacilityStatus';
